<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Base>
    <template v-slot:toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{name: 'crm-index'}" class="text-muted text-hover-primary">
                    <i class="fad fa-comments"></i>
                    {{ trans('Communication') }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <div class="card">
        <div class="card-header">
          <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
            <li class="nav-item">
              <a class="nav-link" :class="{ active: currentTab === 'create' }" @click="currentTab = 'create'">
                <i class="fad fa-plus-circle me-2"></i>
                Créer un lien
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: currentTab === 'list' }" @click="currentTab = 'list'; loadUrls()">
                <i class="fad fa-list me-2"></i>
                Liste des liens
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: currentTab === 'stats' }" @click="currentTab = 'stats'; loadGlobalStats()">
                <i class="fad fa-chart-bar me-2"></i>
                Statistiques
              </a>
            </li>
          </ul>
        </div>

        <div class="card-body">
          <!-- TAB 1: Créer un lien -->
          <div v-if="currentTab === 'create'">
            <div class="row g-3">
              <div class="col-md-5">
                <label class="form-label fw-bold">URL à raccourcir</label>
                <input class="form-control" placeholder="https://example.com/longurl" type="text" v-model="url">
              </div>
              <div class="col-md-3">
                <label class="form-label fw-bold">Code personnalisé (optionnel)</label>
                <input class="form-control" placeholder="mon-lien" type="text" v-model="alias">
              </div>
              <div class="col-md-2">
                <label class="form-label fw-bold">Label (optionnel)</label>
                <input class="form-control" placeholder="Description" type="text" v-model="label">
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button @click="short()" class="btn btn-primary w-100">
                  <i class="fad fa-magic me-2"></i>
                  Raccourcir
                </button>
              </div>
            </div>

            <div v-if="!empty(result)" class="mt-10">
              <div class="alert alert-success d-flex align-items-center justify-content-between">
                <div>
                  <div class="fs-5 fw-bold">Lien créé avec succès!</div>
                  <div class="fs-2 text-primary fw-bolder mt-2">{{ result }}</div>
                </div>
                <button class="btn btn-icon btn-light-primary" @click="copy">
                  <i class="fad fa-copy fs-2x"></i>
                </button>
              </div>

              <div class="d-flex justify-content-center my-5">
                <vue-qr
                  logoSrc="/logo.svg"
                  colorDark="black"
                  colorLight="white"
                  :autoColor="true"
                  class="rounded position-relative border shadow"
                  :text="result"
                  :whiteMargin="true"
                  :qid="result"
                  :size="300"
                ></vue-qr>
              </div>
            </div>
          </div>

          <!-- TAB 2: Liste des liens -->
          <div v-if="currentTab === 'list'">
            <div class="d-flex justify-content-between align-items-center mb-5">
              <div class="d-flex align-items-center">
                <input class="form-control me-2" placeholder="Rechercher..." type="text" v-model="searched" style="width: 300px">
                <button class="btn btn-primary" @click="search">
                  <i class="fad fa-search"></i>
                </button>
              </div>
              <div class="text-muted">
                Total: <span class="fw-bold text-dark">{{ pagination.total }}</span> liens
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4">
                <thead>
                  <tr class="fw-bold text-muted bg-light">
                    <th class="ps-4 min-w-100px">Code</th>
                    <th class="min-w-300px">URL Cible</th>
                    <th class="min-w-150px">Label</th>
                    <th class="min-w-100px text-center">Visites</th>
                    <th class="min-w-150px text-end pe-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="url in urls" :key="url.id">
                    <td class="ps-4">
                      <span class="badge badge-light-primary fs-6">{{ shortLink(url.id) }}</span>
                    </td>
                    <td>
                      <div class="text-dark fw-bold text-hover-primary d-block mb-1 fs-6" style="max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{ url.target }}
                      </div>
                    </td>
                    <td>
                      <span v-if="url.label" class="text-muted">{{ url.label }}</span>
                      <span v-else class="text-muted fst-italic">-</span>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-light-success fs-7">{{ url.visitCount || 0 }}</span>
                    </td>
                    <td class="text-end pe-4">
                      <button class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" @click="copyShortLink(url.id)" title="Copier le lien">
                        <i class="fad fa-copy"></i>
                      </button>
                      <button class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" @click="viewStats(url)" title="Voir les statistiques">
                        <i class="fad fa-chart-line"></i>
                      </button>
                      <button class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm" @click="openQrCode(url.id)" title="QR Code">
                        <i class="fad fa-qrcode"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="d-flex justify-content-between align-items-center mt-5" v-if="pagination.pages > 1">
              <div class="text-muted">
                Page {{ pagination.page }} sur {{ pagination.pages }}
              </div>
              <div class="d-flex">
                <button class="btn btn-sm btn-light me-2" @click="changePage(pagination.page - 1)" :disabled="pagination.page === 1">
                  <i class="fad fa-angle-left"></i>
                </button>
                <button class="btn btn-sm btn-light" @click="changePage(pagination.page + 1)" :disabled="pagination.page === pagination.pages">
                  <i class="fad fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- TAB 3: Statistiques -->
          <div v-if="currentTab === 'stats'">
            <div class="row g-5 g-xl-8">
              <div class="col-xl-3">
                <div class="card card-xl-stretch mb-xl-8 bg-light-primary">
                  <div class="card-body">
                    <i class="fad fa-link fs-2hx text-primary"></i>
                    <div class="text-primary fw-bold fs-2 mb-2 mt-5">{{ globalStats.totalUrls }}</div>
                    <div class="fw-semibold text-gray-600">Total de liens</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="card card-xl-stretch mb-xl-8 bg-light-success">
                  <div class="card-body">
                    <i class="fad fa-eye fs-2hx text-success"></i>
                    <div class="text-success fw-bold fs-2 mb-2 mt-5">{{ globalStats.totalVisits }}</div>
                    <div class="fw-semibold text-gray-600">Total de visites</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="card card-xl-stretch mb-xl-8 bg-light-warning">
                  <div class="card-body">
                    <i class="fad fa-chart-line fs-2hx text-warning"></i>
                    <div class="text-warning fw-bold fs-2 mb-2 mt-5">{{ avgVisitsPerLink }}</div>
                    <div class="fw-semibold text-gray-600">Moyenne par lien</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="card card-xl-stretch mb-xl-8 bg-light-info">
                  <div class="card-body">
                    <i class="fad fa-trophy fs-2hx text-info"></i>
                    <div class="text-info fw-bold fs-2 mb-2 mt-5">{{ mostVisitedLink?.visitCount || 0 }}</div>
                    <div class="fw-semibold text-gray-600">Lien le plus visité</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Graphique des visites journalières -->
            <div class="row mt-5">
              <div class="col-xl-8">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">
                      <i class="fad fa-chart-line me-2 text-primary"></i>
                      Évolution des visites (30 derniers jours)
                    </h3>
                  </div>
                  <div class="card-body">
                    <apexchart
                      v-if="chartSeries[0].data.length > 0"
                      type="line"
                      height="350"
                      :options="chartOptions"
                      :series="chartSeries"
                    ></apexchart>
                    <div v-else class="text-center text-muted py-10">
                      <i class="fad fa-chart-line fs-3x opacity-25 mb-5"></i>
                      <div>Aucune donnée disponible</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Métriques supplémentaires -->
              <div class="col-xl-4">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">
                      <i class="fad fa-calendar-week me-2 text-success"></i>
                      Visites par période
                    </h3>
                  </div>
                  <div class="card-body">
                    <div class="mb-7">
                      <div class="d-flex align-items-center mb-2">
                        <div class="flex-grow-1">
                          <span class="text-gray-800 fw-bold fs-6">7 derniers jours</span>
                        </div>
                        <span class="badge badge-light-success fs-5 px-4 py-2">
                          {{ globalStats.visits7Days }}
                        </span>
                      </div>
                      <div class="separator separator-dashed"></div>
                    </div>
                    <div>
                      <div class="d-flex align-items-center mb-2">
                        <div class="flex-grow-1">
                          <span class="text-gray-800 fw-bold fs-6">30 derniers jours</span>
                        </div>
                        <span class="badge badge-light-info fs-5 px-4 py-2">
                          {{ globalStats.visits30Days }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Top 10 des liens les plus visités -->
            <div class="row mt-5">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">
                      <i class="fad fa-trophy me-2 text-warning"></i>
                      Top 10 des liens les plus visités
                    </h3>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4 mb-0" v-if="globalStats.top10 && globalStats.top10.length > 0">
                        <thead>
                          <tr class="fw-bold text-muted bg-light">
                            <th class="ps-4" style="width: 50px">#</th>
                            <th class="min-w-100px">Code</th>
                            <th class="min-w-300px">URL Cible</th>
                            <th class="min-w-150px">Label</th>
                            <th class="min-w-100px text-end pe-4">Visites</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(link, index) in globalStats.top10" :key="link.id">
                            <td class="ps-4">
                              <div class="badge fs-6" :class="{
                                'badge-light-warning': index === 0,
                                'badge-light-secondary': index === 1,
                                'badge-light-bronze': index === 2,
                                'badge-light': index > 2
                              }">
                                {{ index + 1 }}
                              </div>
                            </td>
                            <td>
                              <span class="badge badge-light-primary fs-6">{{ shortLink(link.id) }}</span>
                            </td>
                            <td>
                              <div class="text-dark fw-bold d-block fs-6" style="max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                {{ link.target }}
                              </div>
                            </td>
                            <td>
                              <span v-if="link.label" class="text-muted">{{ link.label }}</span>
                              <span v-else class="text-muted fst-italic">-</span>
                            </td>
                            <td class="text-end pe-4">
                              <div class="d-flex align-items-center justify-content-end">
                                <span class="badge badge-light-success fs-6 px-4 py-2">
                                  <i class="fad fa-eye me-1"></i>
                                  {{ link.visitCount }}
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else class="text-center text-muted py-10">
                        <i class="fad fa-trophy fs-3x opacity-25 mb-5"></i>
                        <div>Aucun lien visité</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal QR Code -->
      <b-modal id="qrCodeModal" title="QR Code" centered size="md" hide-footer>
        <div class="d-flex justify-content-center p-5">
          <vue-qr
            v-if="selectedUrl"
            logoSrc="/logo.svg"
            colorDark="black"
            colorLight="white"
            :autoColor="true"
            class="rounded position-relative border shadow"
            :text="api.shortener + shortLink(selectedUrl.id)"
            :whiteMargin="true"
            :qid="selectedUrl.id"
            :size="400"
          ></vue-qr>
        </div>
      </b-modal>
    </template>
  </Base>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import Base from "@/layouts/Base.vue";
import {api} from "@/services/Api";
import {helper} from "@/services/Helper";
import Popup from "@/entity/Popup";
import VueQr from 'vue-qr'
import {shortener} from "@/Utils/Shortener";
import VueApexCharts from 'vue-apexcharts'

@Component({
  components: {
    VueQr,
    Base,
    apexchart: VueApexCharts
  }
})
export default class UrlShortener extends Vue {
  [x: string]: any;

  api = api
  websiteUrl = process.env.VUE_APP_WEBSITE_URL
  result = ''
  url = ''
  alias = ''
  label = ''
  currentTab = 'create'

  urls: any[] = []
  searched = ''
  selectedUrl: any = null

  pagination = {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0
  }

  globalStats = {
    totalUrls: 0,
    totalVisits: 0,
    avgVisitsPerUrl: 0,
    visits7Days: 0,
    visits30Days: 0,
    top10: [],
    dailyStats: {}
  }

  chartOptions: any = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: {
        show: true
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    xaxis: {
      type: 'datetime',
      labels: {
        format: 'dd/MM'
      }
    },
    yaxis: {
      title: {
        text: 'Visites'
      }
    },
    colors: ['#009EF7'],
    tooltip: {
      x: {
        format: 'dd/MM/yyyy'
      }
    }
  }

  chartSeries: any = [{
    name: 'Visites',
    data: []
  }]

  shortLink(id: number) {
    return shortener.converIdToCHar(id)
  }

  copyShortLink(id: number) {
    const link = api.shortener + shortener.converIdToCHar(id)
    navigator.clipboard.writeText(link);
    new Popup('Lien Copié', link, 'success', 'fad fa-copy')
  }

  get avgVisitsPerLink() {
    return this.globalStats.avgVisitsPerUrl || 0
  }

  get mostVisitedLink() {
    if (this.globalStats.top10 && this.globalStats.top10.length > 0) {
      return this.globalStats.top10[0]
    }
    return null
  }

  async copy() {
    if (this.result) {
      navigator.clipboard.writeText(this.result).then(() => {
        new Popup('Copie Effectuée', 'Lien Copié', 'success')
      })
    }
  }

  async search() {
    if (!helper.empty(this.searched)) {
      const res = await api.post(api.shortener, 'url/search', {searched: this.searched})
      if (res && res.data && res.data.urls) {
        this.urls = res.data.urls
      }
    } else {
      this.loadUrls()
    }
  }

  async short() {
    if (!helper.empty(this.url)) {
      const res = await api.post(api.shortener, 'url/short', {
        'link': this.url,
        'alias': this.alias,
        'label': this.label
      })
      if (res && res.data && res.data.link) {
        this.result = res.data.link
        // Réinitialiser le formulaire
        this.url = ''
        this.alias = ''
        this.label = ''
      }
    } else {
      new Popup('URL Vide', 'Veuillez entrer un lien à raccourcir', 'warning')
    }
  }

  async loadUrls() {
    const res = await api.get(api.shortener, 'url/list', {
      params: {
        page: this.pagination.page,
        limit: this.pagination.limit
      }
    })

    if (res && res.data) {
      this.urls = res.data.urls || []
      if (res.data.pagination) {
        this.pagination = res.data.pagination
      }
      if (res.data.stats) {
        this.globalStats = res.data.stats
      }
    }
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.pagination.pages) {
      this.pagination.page = page
      this.loadUrls()
    }
  }

  openQrCode(url: any) {
    this.selectedUrl = url
    this.$bvModal.show('qrCodeModal')
  }

  async loadGlobalStats() {
    const res = await api.get(api.shortener, 'url/global/stats')

    if (res && res.data && res.data.stats) {
      this.globalStats = res.data.stats

      // Préparer les données pour le graphique
      if (this.globalStats.dailyStats) {
        const dailyData = Object.entries(this.globalStats.dailyStats).map(([date, count]) => {
          return {
            x: new Date(date).getTime(),
            y: count
          }
        })
        this.chartSeries = [{
          name: 'Visites',
          data: dailyData
        }]
      }
    }
  }

  viewStats(url: any) {
    // TODO: Implémenter la vue détaillée des statistiques
    new Popup('Statistiques', 'Fonctionnalité à venir', 'info')
  }

  async mounted() {
    this.loadUrls()
    this.loadGlobalStats()
  }
}
</script>

<style scoped>
.nav-link {
  cursor: pointer;
}
</style>
